import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../utils";
import { FaSpinner } from "react-icons/fa6";
import { getUserRole, getUserRoleAndStep } from "./PrivateRoute";
import { Button } from "antd";
import Cookies from "js-cookie";
import { logIn } from "../../Api/api";
import { useDispatch, useSelector } from "react-redux";

const LogInForm = () => {
  const [formData, setFormData] = useState({
    email: "rob@gmail.com",
    password: "123",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showOTPField, setShowOTPField] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value); // Log the name and value to verify they're correct
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await logIn(formData); // Use the logIn function for login logic
      const token = response.access_token;
      document.cookie = `jwtToken=${token}`;
      console.log("JWT Token saved as cookie:", token);
      showToast("You are Successfully logged In");

      // Fetch additional user data after successful login

      // Update user role and steps
      await getUserRoleAndStep(dispatch);

      const additionalDataResponse = await axios.get(
        `${import.meta.env.VITE_API_URL}/user`
      );
      console.log("Additional Data Response: ", additionalDataResponse);
      const step = Number(additionalDataResponse.data.step);
      const userRole = additionalDataResponse.data.role;
      console.log("User Role:", userRole);

      // Redirect based on the user's step and role

      if (step === 1) {
        if (userRole === "user") {
          navigate("/register");
        } else if (userRole === "individual") {
          navigate("/onboarding/userform");
        } else if (userRole === "admin") {
          navigate("/onboarding/ngoform");
        }
      } else if (step === 2) {
        if (userRole === "individual") {
          navigate("/onboarding/userdocuments");
        } else if (userRole === "admin") {
          navigate("/onboarding/ngodocuments");
        } else if (userRole === "user") {
          navigate("/");
        }
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error(
        "Error detected in server",
        error.response?.status || error.message
      );
      setIsLoading(false);

      // Handle different error scenarios
      if (error.response?.status === 404) {
        showToast("Login failed. Internal Server Error");
      } else {
        showToast("Login failed. Please check your credentials and try again.");
      }
    } finally {
      setIsLoading(false); // Ensure loading state is reset
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen max-h-[100vh]">
      <div className="h-64 md:h-full md:w-2/5 max-h-[100vh]">
        <img
          className="max-h-[100vh] w-full object-cover"
          src="https://d1irs7zslorh1g.cloudfront.net/assets/login-1.jpg"
          alt="login-image"
        />
      </div>
      {!showOTPField && (
        <div className="flex flex-col justify-center p-6 md:p-12 w-full md:w-3/5 bg-white max-h-screen overflow-auto">
          <form onSubmit={handleSubmit} className="max-w-md mx-12">
            <div className="flex items-center justify-between mt-4">
              <p>Not a member?</p>
              <p
                onClick={() => navigate("/register")}
                className="text-btn-1 cursor-pointer"
              >
                Register
              </p>
            </div>
            <h1 className="text-2xl mb-3 mt-8">Log In to Your Account</h1>
            <div className="py-3">
              <label htmlFor="email" className="block">
                Email:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="border rounded-lg py-2 w-full px-2"
                required
              />
            </div>
            <div className="py-3">
              <label htmlFor="password" className="block">
                Password:
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="border rounded-lg py-2 w-full px-2"
                required
              />
            </div>
            <button
              type="submit"
              className="rounded-lg bg-btn-1 text-white w-full py-2 text-md mt-4"
            >
              {isLoading ? (
                <div className="flex items-center justify-center">
                  <FaSpinner className="animate-spin"/>
                </div>
              ) : (
                "Login"
              )}
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default LogInForm;
